module.exports = __webpack_public_path__ + "img/bilge.b83f5daa.png";